import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { func, bool, string } from 'prop-types'
import { Row, Col, FormGroup, Table } from 'react-bootstrap'

import FormInput from '../FormInput'
import FormTextarea from '../FormTextarea'
import FormDatePicker from '../FormDatePicker'

const required = value => value ? undefined : 'Campo obrigatório'

class VideoConfigForm extends Component {
  constructor () {
    super()

    this.state = {
      activeTab: 'dados',
      page: 1,
      all_false: false
    }

    this.changingTab = this.changingTab.bind(this)
  }
  changingTab (activeKey) {
    this.setState({
      activeTab: activeKey
    })
  }
  componentDidMount () {
    if (this.props.initialValues) {
      this.setState({
        all_false: this.props.initialValues.has_no_personalized_fields || false
      })
    }
  }
  render () {
    const {
      error,
      handleSubmit,
      loading
      // pristine,
      // submitting,
      // userEmail,
      // cancelEdit,
    } = this.props
    return (
      <form onSubmit={handleSubmit}>
        <div className={this.state.page === 1 ? '' : 'hidden'}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Field
                  type='text'
                  name='title'
                  component={FormInput}
                  label='Título:'
                  placeholder='Título do video'
                  direction='vertical'
                  validate={required}
                  loading={loading}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Field
                  type='text'
                  name='id_menu'
                  component={FormInput}
                  label='ID Menu:'
                  placeholder='ID Menu:'
                  direction='vertical'
                  validate={required}
                  loading={loading}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Field
                  type='text'
                  name='text'
                  component={FormTextarea}
                  label='Texto:'
                  placeholder='Texto do video'
                  direction='vertical'
                  validate={required}
                  loading={loading}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Field
                  name='start_date'
                  component={FormDatePicker}
                  label='Data de Início:'
                  direction='vertical'
                  validate={required}
                  loading={loading}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Field
                  name='end_date'
                  component={FormDatePicker}
                  label='Data Final:'
                  direction='vertical'
                  validate={required}
                  loading={loading}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <label>Segmento:</label>
                <br />
                <label className='checkbox-inline'>
                  <Field
                    name='segment[personalite]'
                    component='input'
                    type='checkbox'
                    disabled={loading}
                  />
                  Personalité
                </label>
                <label className='checkbox-inline'>
                  <Field
                    name='segment[uniclass]'
                    component='input'
                    type='checkbox'
                    disabled={loading}
                  />
                  Uniclass
                </label>
                <label className='checkbox-inline'>
                  <Field
                    name='segment[varejo]'
                    component='input'
                    type='checkbox'
                    disabled={loading}
                  />
                  Varejo
                </label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <FormGroup>
                <label>Produto:</label>
                <Field name='product' component='select' className='form-control'>
                  <option />
                  <option value='Investimento'>Investimento</option>
                  <option value='Crédito Consignado'>Crédito Consignado</option>
                  <option value='Empréstimo Pessoal com proteção (Leve Mais)'>Empréstimo Pessoal com proteção (Leve Mais)</option>
                  <option value='Empréstimo Pessoal sem proteção (Leve Mais)'>Empréstimo Pessoal sem proteção (Leve Mais)</option>
                  <option value='Crediflex'>Crediflex</option>
                  <option value='Crédito com Garantia de Investimento'>Crédito com Garantia de Investimento</option>
                  <option value='Empréstimo em parcela única: Antecipação do 13º salário e Antecipação do IR'>Empréstimo em parcela única: Antecipação do 13º salário e Antecipação do IR</option>
                  <option value='Cheque Especial (Lis)'>Cheque Especial (Lis)</option>
                  <option value='Consórcio: Imóveis, carros e motos'>Consórcio: Imóveis, carros e motos</option>
                </Field>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {error && <strong className='text-danger'>{error}</strong>}
              {this.props.submitFailed && <strong className='text-danger'>Verifique se todos os campos obrigatórios foram preenchidos.</strong>}
            </Col>
          </Row>
          <FormGroup className='mt20'>
            <div className='pull-right'>
              <a
                className='btn btn-default'
                onClick={(e) => {
                  e.preventDefault()
                  this.setState({ page: 2 })
                }}
              >
                Próxima
              </a>
            </div>
          </FormGroup>
        </div>
        <div className={this.state.page === 2 ? '' : 'hidden'}>
          <Row>
            <Col md={12}>
              <FormGroup>
                <label>Campos Personalizáveis:</label>
                <br />
                <Table>
                  <thead>
                    <tr>
                      <th />
                      <th>Nome</th>
                      <th>Descrição</th>
                      <th>Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[user_name]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>user_name</td>
                      <td>Nome do usuário, usado para saudação.</td>
                      <td>Texto</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[min_value]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>min_value</td>
                      <td>Valor mínimo permitido, usado para validação do input.</td>
                      <td>Financeiro</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[max_value]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>max_value</td>
                      <td>Valor máximo permitido, usado para validação do input.</td>
                      <td>Financeiro</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[original_proposal_value]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>original_proposal_value</td>
                      <td>Valor total da proposta original.</td>
                      <td>Financeiro</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[original_split_value]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>original_split_value</td>
                      <td>Valor da parcela da proposta original.</td>
                      <td>Financeiro</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[original_splits]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>original_splits</td>
                      <td>Número de parcelas da proposta original.</td>
                      <td>Número</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[new_proposal_value]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>new_proposal_value</td>
                      <td>Valor total da nova proposta.</td>
                      <td>Financeiro</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[new_split_value]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>new_split_value</td>
                      <td>Valor da parcela da nova proposta.</td>
                      <td>Financeiro</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[new_splits]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>new_splits</td>
                      <td>Número de parcelas da nova proposta.</td>
                      <td>Número</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[proposal_value]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>proposal_value</td>
                      <td>Valor total da proposta.</td>
                      <td>Financeiro</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[split_value]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>split_value</td>
                      <td>Valor da parcela da proposta.</td>
                      <td>Financeiro</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[proposal_splits]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>proposal_splits</td>
                      <td>Número de parcelas da proposta.</td>
                      <td>Número</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[reserva]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>reserva</td>
                      <td>Indicador se usuário tem ou não reserva financeira.</td>
                      <td>Verdadeiro ou Falso</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='personalized_fields[investment_profile]'
                          component='input'
                          type='checkbox'
                          disabled={loading || this.state.all_false}
                        />
                      </td>
                      <td>investment_profile</td>
                      <td>Perfil de investidor do usuário. Pode ser "moderado", "arrojado" ou "agressivo".</td>
                      <td>Texto</td>
                    </tr>
                    <tr>
                      <td>
                        <Field
                          name='has_no_personalized_fields'
                          component='input'
                          type='checkbox'
                          disabled={loading}
                          onChange={() => {
                            this.setState({
                              all_false: !this.state.all_false
                            })
                          }}
                        />
                      </td>
                      <td colSpan='3'>Marque se o video não tiver campos parametrizados.</td>
                    </tr>
                  </tbody>
                </Table>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {error && <strong className='text-danger'>{error}</strong>}
              {this.props.submitFailed && <strong className='text-danger'>Verifique se todos os campos obrigatórios foram preenchidos.</strong>}
            </Col>
          </Row>
          <FormGroup className='mt20'>
            <div className='pull-right'>
              <button type='submit' className='btn btn-primary' disabled={loading}>Salvar</button>
            </div>
            <div className='pull-right'>
              <a
                className='btn btn-default'
                onClick={() => this.setState({ page: 1 })}
              >
                Voltar
              </a>
            </div>
          </FormGroup>
        </div>
      </form>
    )
  }
}

VideoConfigForm.propTypes = {
  handleSubmit: func,
  error: string,
  loading: bool,
  submitFailed: bool
}

export default reduxForm({ form: 'videoConfigForm' })(VideoConfigForm)



// WEBPACK FOOTER //
// ./src/components/forms/VideoConfigForm.js